<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <app-appointment-toolbar [appointmentNumber]="appointmentNumber" [isReadOnly]="toolbarIsReadOnly"
            [isSubmitting]="isSubmitting" [isLoading]="isLoading" (cancelClick)="cancel()" (save)="onSaveClick($event)"
            (shuntMoveClick)="addShuntMove()" (completeClick)="complete()" (assignToUnloadClick)="assignToUnload()"
            [appointmentActions]="this.appointment.actions">
        </app-appointment-toolbar>
    </div>
    <dx-load-panel container=".view-wrapper-scroll" [visible]="isLoading" [showPane]="false"
        [position]="{ of: 'appointment-details' }">
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">
                    @if(showDetails) {
                        <div class="card border-0 shadow-sm pt-0 mb-4">
                            <div class="card-header d-flex justify-content-between align-items-center fs-5 fw-medium">
                                <span>Appointment Details</span>
                                <span class="text-muted fs-5">
                                    @if (appointmentNumber) {
                                        ID: {{ appointment.numberWithPrefix }}
                                    }
                                </span>
                            </div>
                            <div class="card-body">
                                @if (appointmentNumber) {
                                    <div class="row mb-3">
                                        <div class="col-6">
                                            <strong class="me-2">Status: </strong>
                                            <span class="badge" [ngClass]="getBadgeClass(appointment.status)">
                                                {{ appointment.status | appointmentStatus }}
                                            </span>
                                        </div>
                                        @if (this.appointment.emptyCheckInNumber) {
                                            <div class="col-6">
                                                <strong class="me-2">Empty Trailer: </strong>
                                                <a [routerLink]="`/inbound/empty-check-ins/details/${this.appointment.emptyCheckInNumber}`"
                                                    class="text-decoration-none">{{ this.appointment.emptyCheckInNumber }}</a>
                                            </div>
                                        }
                                        @if (this.appointment.emptyCheckOutNumber) {
                                            <div class="col-6">
                                                <strong class="me-2">Outbound: </strong>
                                                <a [routerLink]="`/outbound/empty-check-outs/details/${this.appointment.emptyCheckOutNumber}`"
                                                    class="text-decoration-none">{{ this.appointment.emptyCheckOutNumber }}</a>
                                            </div>
                                        }
                                    </div>
                                }
                                <div class="row g-3 mt-1">
                                    <div class="col-md-4">
                                        <label class="form-label">Supplier: <span class="text-danger">*</span></label>
                                        <dx-select-box [(value)]="appointment.supplierId" [dataSource]="supplierDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isDetailsReadOnly"
                                            (onValueChanged)="onSupplierChanged($event)">
                                            <dx-validator>
                                                <dxi-validation-rule type="required" message="Supplier is required"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-select-box>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Carrier: <span class="text-danger">*</span></label>
                                        <dx-select-box [(value)]="appointment.carrierId" [dataSource]="carrierDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isDetailsReadOnly">
                                            <dx-validator>
                                                <dxi-validation-rule type="required" message="Carrier is required"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-select-box>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Warehouse:</label>
                                        <dx-select-box value="HDC Brampton" [items]="['HDC Brampton']" stylingMode="filled"
                                            [readOnly]="isDetailsReadOnly" placeholder="Select Warehouse">
                                        </dx-select-box>
                                    </div>
                                </div>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-4">
                                        <label class="form-label">Bill Of Lading Number:</label>
                                        <dx-text-box stylingMode="filled" [(value)]="appointment.billOfLadingNumber"
                                            maxLength="100" placeholder="Enter Bill Of Lading Number"
                                            [readOnly]="isDetailsReadOnly">
                                        </dx-text-box>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">PO# or STO#:</label>
                                        <dx-tag-box [(value)]="appointment.purchaseOrders"
                                            [dataSource]="purchaseOrderDataSource"
                                            displayExpr="purchasingDocument"
                                            valueExpr="purchasingDocument"
                                            [searchEnabled]="true"
                                            [showClearButton]="true"
                                            stylingMode="filled"
                                            placeholder="Select PO# or STO#"
                                            [readOnly]="isDetailsReadOnly || !appointment.supplierId"
                                            (onValueChanged)="onPurchaseOrderChanged($event)">
                                            <dx-validator>
                                                <dxi-validation-rule type="custom" [validationCallback]="validatePurchaseOrders" message="PO# or STO# is required"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-tag-box>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Pallet Count:</label>
                                        <dx-number-box [(value)]="appointment.palletCount" [min]="0" stylingMode="filled"
                                            [showSpinButtons]="true" [readOnly]="isDetailsReadOnly"></dx-number-box>
                                    </div>
                                </div>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-4">
                                        <label class="form-label">Load Type:</label>
                                        <dx-select-box [(value)]="appointment.loadType" [items]="loadTypeOptions"
                                            valueExpr="value" displayExpr="text" stylingMode="filled"
                                            placeholder="Select Load Type" [readOnly]="isDetailsReadOnly">
                                            <dx-validator>
                                                <dxi-validation-rule type="custom" [validationCallback]="validateConditionallyRequired" message="Load Type is required"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-select-box>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Trailer Number:</label>
                                        <dx-text-box stylingMode="filled" [(value)]="appointment.trailerNumber" maxLength="100"
                                            placeholder="Enter trailer number" [readOnly]="isDetailsReadOnly">
                                            <dx-validator>
                                                <dxi-validation-rule type="custom" [validationCallback]="validateConditionallyRequired" message="Trailer Number is required"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-text-box>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Weight of Shipment:</label>
                                        <dx-text-box stylingMode="filled" [(value)]="appointment.weightOfShipment"
                                            maxLength="100" placeholder="Enter weight of shipment"
                                            [readOnly]="isDetailsReadOnly">
                                        </dx-text-box>
                                    </div>
                                </div>
                                <hr />
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <app-appointment-date-time
                                            [(date)]="appointment.requestDate"
                                            labelPrefix="Appointment Request"
                                            [isReadOnly]="isDetailsReadOnly || appointment.showConfirmedDate">
                                        </app-appointment-date-time>
                                    </div>
                                    @if(appointment.showConfirmedDate) {
                                        <div class="col-md-6">
                                            <app-appointment-date-time
                                                [(date)]="appointment.confirmedDate"
                                                labelPrefix="Confirmed Appointment"
                                                [isReadOnly]="confirmedDateIsReadOnly"
                                                [showAppointmentCount]="!confirmedDateIsReadOnly"
                                                [Id]="appointment.id"
                                                [applyStandardTimeLimits]="false">
                                            </app-appointment-date-time>
                                        </div>
                                    }
                                </div>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <file-upload label="Upload Packing Slip:"
                                            [(value)]="newPackingSlipFiles" [maxFileSize]="maxFileSize" [maxFileNumber]="3"
                                            [(existingFiles)]="appointment.packingSlipFiles"
                                            [(filesToRemove)]="packingSlipFilesToRemove" [isReadOnly]="isDetailsReadOnly">
                                        </file-upload>
                                    </div>
                                    <div class="col-md-6">
                                        <file-upload label="Upload Other Files:" [(value)]="newOtherFiles"
                                            [maxFileSize]="maxFileSize" [isReadOnly]="isDetailsReadOnly" [maxFileNumber]="3"
                                            [(existingFiles)]="appointment.otherFiles" [(filesToRemove)]="otherFilesToRemove">
                                        </file-upload>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    @if(showGuardHouse) {
                        <app-guard-house [appointment]="appointment" [carrierDataSource]="this.carrierDataSource" [isReadOnly]="guardHouseIsReadOnly"/>
                    }
                </div>
                <div class="mt-4">
                    <app-notes
                        [entityId]="appointmentNumber"
                        [noteType]="NoteType.Appointment"
                        [canCreate]="true"
                        (noteSaved)="onNoteSaved()"
                        (noteCanceled)="onNoteCanceled()"
                    ></app-notes>
                </div>
            }
        </dx-validation-group>

        @if(showDetails)
        {
            <app-purchase-order-items [purchaseOrderItems]="purchaseOrderItems" [showPurchasingOrder]="true"></app-purchase-order-items>
        }
        @if (showCompliance) {
            <app-appointment-compliance [appointmentNumber]="this.appointmentNumber" [showEditButton]="canEditCompliance" />
        }
    </dx-scroll-view>

    <shunt-move-form [(visible)]="isAddShuntMovePopupOpened" (onSave)="onShuntMovePopupSaveClick()" [titlePrefix]="'Add'"></shunt-move-form>
    <form-popup [(visible)]="isAssignToUnloadPopupOpened" (save)="onAssignToUnloadPopupSaveClick()" titleText="Assign to Unload">
        <assign-to-unload-form></assign-to-unload-form>
    </form-popup>
    <complete-form [(visible)]="isCompletePopupOpened" (onSave)="onCompletePopupSaveClick()"></complete-form>
</div>
